import { Check } from "lucide-react";
import type { FC } from "react";
import React from "react";

import type { TCurrentStep } from "./uploadLeadsDialog";

// Move type alias here to fix linter error

const steps = [
  {
    key: "upload",
    label: "Upload CSV",
  },
  {
    key: "mapping",
    label: "Match Columns",
  },
  {
    key: "complete",
    label: "Complete",
  },
] as const;

const ProgressSteps: FC<{ currentStep: TCurrentStep }> = function ({
  currentStep,
}) {
  const getStepStatus = (stepKey: TCurrentStep) => {
    const stepOrder = steps.map((s) => s.key);
    const currentIdx = stepOrder.indexOf(currentStep);
    const stepIdx = stepOrder.indexOf(stepKey);
    if (stepIdx < currentIdx) return "complete";
    if (stepIdx === currentIdx) return "active";
    return "inactive";
  };

  return (
    <div className="flex items-center justify-center mb-2">
      <div className="flex items-center space-x-4">
        {steps.map((step, idx) => {
          const status = getStepStatus(step.key);
          const isLast = idx === steps.length - 1;
          let textColor = "text-gray-400";
          let bgColor = "bg-gray-100";
          if (status === "active") {
            textColor = "text-blue-600";
            bgColor = "bg-blue-100";
          } else if (status === "complete") {
            textColor = "text-green-600";
            bgColor = "bg-green-100";
          }
          return (
            <React.Fragment key={step.key}>
              <div className={`flex items-center space-x-2 ${textColor}`}>
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center ${bgColor}`}
                >
                  {status === "complete" ? <Check size={16} /> : idx + 1}
                </div>
                <span className="font-medium">{step.label}</span>
              </div>
              {!isLast && <div className="w-8 h-px bg-gray-300" />}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressSteps;
